import { createModule, constants } from "./redux-acron";
import api from "services/api";
import { call, put, select, all } from 'redux-saga/effects';
import moment from "moment";

/**
 * Alerts Module
 * reducer/sagas/actions
 *
 * TODO: Agregar todos los handlers y effects para los diferentes indicadores
 */

export default createModule({
  name: "dashboard",
  modelName: "dashboard",

  state: {
    loading: {},
    error: {},

    filters: {
      dateFrom: moment()
        .subtract(1, "month")
        .format("YYYY-MM-DD"),
      dateTo: moment()
        .add(1, "day")
        .format("YYYY-MM-DD"),
      clusterInclude: null,
      logicalLocationInclude: null,
      geoLocationInclude: null,
      criticalMomentInclude: null
    },

    clusters: [],
    logicalLocations: [],
    geoLocations: [],
    criticalMoments: [],

    values: {
      alerts: [
        {
          answered: 0,
          not_handled: 0,
          in_progress: 0,
          closed: 0
        }
      ]
    },
  },

  // ------

  handlers: {
    getData: (state, { payload, status = constants.PENDING_STATUS, }) => {
      if (status === constants.PENDING_STATUS) {
        return state.merge({
          loading: {
            ...state.loading,
            [payload.name]: true,
          },
          values: {
            ...state.values,
            [payload.name]: null
          },
        })
      }

      if (status === constants.SUCCESS_STATUS) {
        return state.merge({
          loading: {
            ...state.loading,
            [payload.name]: false,
          },
          values: {
            ...state.values,
            [payload.name]: payload.data
          },
        })
      }

      return state
    },
    getClusters: (state, { payload, status = constants.PENDING_STATUS }) => {
      return handlerWrapper("clusters", state, status, payload);
    },
    getLogicalLocations: (
      state,
      { payload, status = constants.PENDING_STATUS }
    ) => {
      return handlerWrapper("logicalLocations", state, status, payload);
    },
    getGeoLocations: (
      state,
      { payload, status = constants.PENDING_STATUS }
    ) => {
      return handlerWrapper("geoLocations", state, status, payload);
    },
    setFilters: (state, { payload }) => {
      const newData = { data: [{ ...payload.filters }] };
      return state.merge({
        loading: true,
        filters: newData.data[0]
      });
    },
    clearErrors: state => {
      return state.merge({
        loading: false,
        error: []
      });
    }

  },

  effects: {
    getData: {
      type: 'all',
      * callback(actions, { payload, }) {
        const { user, } = yield select()
        const { url, singleton, groupBy, name, tag } = payload

        const response = yield call(
          api.dashboard.getData, url,
          { ...payload, userId: user.data.id, groupBy, tag }
        )
        if (response.ok) {
          const data = singleton ? response.data[0] : response.data;

          yield put(
            actions.getData(
              { data, name },
              constants.SUCCESS_STATUS,
            ),
          )
        }
      },
    },
    // Get Clusters info
    getClusters: {
      callback(actions) {
        return handlerEffects(
          api.referenceData.clusters,
          null,
          actions.getClusters
        );
      }
    },
    // Get Logical Locations info
    getLogicalLocations: {
      callback(actions) {
        return handlerEffects(
          api.referenceData.logicalLocations,
          null,
          actions.getLogicalLocations
        );
      }
    },
    // Get Geo Location info
    getGeoLocations: {
      callback(actions) {
        return handlerEffects(
          api.referenceData.geoLocations,
          null,
          actions.getGeoLocations
        );
      }
    },
  }
});



// WEBPACK FOOTER //
// ./src/modules/DashboardModule.js